<template>
  <div>
<!--    <div class="search-nav">-->
<!--      <div class="search-nav-container">-->
<!--        <ul>-->
<!--          <li>商品添加</li>-->
<!--        </ul>-->
<!--      </div>-->
<!--    </div>-->
    <div style="margin: 0px 10px 0px 10px;">
      <el-form :inline="true" :model="addParams">
        <el-form-item>
          <el-button @click="addGood">添加商品</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog :title="title" :visible.sync="open" width="1000px" append-to-body>
      <el-form ref="form" :inline="true" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="商品名称" prop="name">
          <el-input class="input-style" v-model="form.name"/>
        </el-form-item>
        <el-form-item label="商品编码" prop="number">
          <el-input class="input-style" v-model="form.number"/>
        </el-form-item>
        <el-form-item label="商品详情" prop="detail">
          <el-input type="textarea" class="input-style" v-model="form.detail"/>
        </el-form-item>
        <el-form-item label="简称" prop="short_name">
          <el-input class="input-style" v-model="form.short_name"/>
        </el-form-item>
        <el-form-item label="规格型号" prop="model">
          <el-input class="input-style" v-model="form.model"/>
        </el-form-item>
        <el-form-item label="包装规格" prop="packaging_specification">
          <el-input class="input-style" v-model="form.packaging_specification"/>
        </el-form-item>
        <el-form-item label="助记码" prop="help_code">
          <el-input class="input-style" v-model="form.help_code"/>
        </el-form-item>
        <el-form-item label="计量单位" prop="base_unit">
          <el-input class="input-style" v-model="form.base_unit"/>
        </el-form-item>
        <el-form-item label="品牌" prop="registered_mark">
          <el-input class="input-style" v-model="form.registered_mark"/>
        </el-form-item>
        <el-form-item label="所属分类id" prop="group_id">
          <el-input class="input-style" v-model="form.group_id"/>
        </el-form-item>
        <el-form-item label="租户编号" prop="tenant_id">
          <el-input class="input-style" v-model="form.tenant_id"/>
        </el-form-item>
        <el-form-item label="是否上架" prop="is_sale" >
          <el-switch v-model="form.is_sale" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>


        <el-form-item label="添加头图">
          <el-upload ref="upload" :file-list="fileList" :class="{hide:photoHide}"
                     :on-change="handleChange" :on-remove="photoRemove" list-type="picture-card"
                     action="#" :auto-upload="false"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import {saveBo} from "@/api/system/good";

import {saveBo as saveCommerceBo} from "@/api/system/material_commerce";

export default {
  name: "index",

  components:{
  },

  methods:{

    addGood() {
      // this.reset();
      this.open = true;
      this.title = "添加商品";
      this.$nextTick(() => {
        // this.$refs.menuTree.setCheckedKeys([]);
      });
    },

    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // if (this.form.id) {
          // updateByBo(this.form).then(res => {
          //   this.$modal.msgSuccess("修改成功");
          //   this.open = false;
          //   this.getList();
          //   this.assignResources();
          // });
          // alert("您输入的商品编码已存在")
          // } else {
          // this.form.clientId = this.addParams.clientId;
          saveBo(this.form).then(res => {
            this.form.id = res.data;
            // this.getList();
            // this.assignResources();
          });
          let goodCommerce = new Object();
          goodCommerce.name = this.form.name;
          goodCommerce.material_id = this.form.id;
          goodCommerce.is_sale = this.form.is_sale;
          goodCommerce.detail = this.form.detail;
          goodCommerce.tenant_id = this.form.tenant_id;
          goodCommerce.is_deleted = this.form.is_deleted;

          saveCommerceBo(goodCommerce).then(res =>{
            this.$modal.msgSuccess("添加成功");
            this.open = false;

          })


          // }
        }
      });
    },

    cancel() {
      this.open = false;
      this.reset();
    },

    reset() {
      this.form = {
        name: undefined,
        number: undefined,

        dataScope: 0,
        status: 0
      };
    },

    handleChange(file,fileList){//图片上传
      let formData=new FormData()
      formData.append('file',file.raw)
      commonUpLoad(formData).then(res=>{
        this.picUrl=res.data.url
        this.detailForm.picId=res.data.pic_id
      })
      this.photoHide=fileList.length>=1;
    },
    photoRemove(file,fileList){//图片移除
      this.photoHide=fileList.length>=1;
      this.picUrl=''
    }
  },

  data () {
    return {
      addParams:{
        name:'',
        id:'',
        short_name:'',
        model:'',
        packaging_specification:'',
        help_code:'',
        base_unit:'',
        registered_mark:'',
        group_id:'',
        tenant_id:'',
        create_user:'',
        update_user:'',
        isDeleted: 0,
        erp_source:'',

        is_sale:'',
        detail:'',
        head_uri:'',
      },

      open:false,
      title: "",
      form: {
        is_sale: "1",
        is_deleted: "0",
      },

      photoHide:false,
      picUrl:'',
      fileList:[],

      rules: {
        name: [
          { required: true, message: "商品名称不能为空", trigger: "blur" }
        ],
        number: [
          { required: true, message: "商品编码不能为空", trigger: "blur" }
        ],
        model:[
          { required: true, message: "商品规格型号不能为空", trigger: "blur" }
        ],
        base_unit:[
          { required: true, message: "商品计量单位不能为空", trigger: "blur" }
        ],
        group_id:[
          { required: true, message: "商品所属分类不能为空", trigger: "blur" }
        ],
        tenant_id:[
          { required: true, message: "租户编号不能为空", trigger: "blur" }
        ],
      },
    }
  }

}
</script>
<style scoped>
.search-nav{
  width: 100%;
  height: 64px;
  border-bottom: 2px solid #B1191A;
}
.search-nav-container{
  align-content: center;
  width: auto;
  min-width: 1000px;
  height: 64px;
  margin: 0px auto;
}
.search-nav-container-90{
  width: 90%;
}
.search-nav-container ul{
  /*margin: 0px;*/
  /*padding-left: 0px;*/
  list-style: none;
  align-content: center;
}
.search-nav-container li{
  cursor: pointer;
  margin-left: 30px;
  line-height: 64px;
  color: #C81623;
  font-size: 18px;
  /*font-weight: bold;*/
  float: left;
}
.search-nav-container a{
  color: #C81623;
  text-decoration: none;
}
.search-nav-container li:first-child{
  padding: 0px 38px;
  background:#B1191A;
  margin: 0px;
  color: #fff;
}




</style>
